'use client';

import type { Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';
import { QueryProvider } from '@/shared/components/QueryProvider';
import { TelegramMiniAppAuth } from './TelegramMiniAppAuth';
import { CurrentUserProvider } from './CurrentUserProvider';

interface AuthWrapperProps {
  children: React.ReactNode;
  session?: Session | null;
}

export default function AuthWrapper({ children, session }: AuthWrapperProps) {
  return (
    <SessionProvider
      session={session ?? undefined}
      refetchInterval={0} // Disable periodic refetch — user data comes via React Query
      refetchOnWindowFocus={false}
    >
      <QueryProvider>
        <CurrentUserProvider>
          {/* Auto-authenticate in Telegram Mini App */}
          <TelegramMiniAppAuth />
          {children}
        </CurrentUserProvider>
      </QueryProvider>
    </SessionProvider>
  );
}
